import { useAppSelector } from '../../../../../hooks/hooks';
import { toBoolean } from '../../../../../utils/util';
import { SimpleButton } from '../../../../common';
import { IButton } from './SchedulerMini';

const StageButton = ({
  button: {
    action,
    isDisabled,
    isSelectedSelector,
    label,
    title,
    value,
    ...props
  },
}: {
  button: IButton;
}) => {
  const isSelected = useAppSelector(isSelectedSelector);
  const showDisponibility = useAppSelector((global) => {
    return global.schedulerSlice?.showDisponibility;
  });

  const overassign = useAppSelector((global) => {
    return global.schedulerSlice?.overassign;
  });

  return (
    <SimpleButton
      {...window.getVariant('outline')}
      className={`${isSelected ? 'selected' : ''} ${
        value !== '' && !Number(value) && Number(value) <= Number(overassign)
          ? 'td_overassign'
          : ''
      } ${isDisabled ? 'disabled' : ''} stage_btn`}
      onClick={action}
      key={title}
      disabled={isDisabled}
      {...props}
    >
      {label}{' '}
      {toBoolean(showDisponibility) &&
        value !== '' &&
        `(${Number(value) + Number(overassign) || Number(overassign)})`}
    </SimpleButton>
  );
};

export default StageButton;
